import { useCallback, useRef, useState } from "react";
import { GlDrillDownParams } from "./glDrillDown.lib";

export function useGlDrilldownDrawerState() {
    const [target, setTarget] = useState<GlDrillDownParams | null>(null);
    const [drawerKey, setDrawerKey] = useState(0);

    const openDrillDown = useCallback((next: GlDrillDownParams) => {
        setDrawerKey((key) => key + 1);
        setTarget(next);
    }, []);

    const closeDrillDown = useCallback(() => {
        setTarget(null);
    }, []);

    const lastTargetRef = useRef<GlDrillDownParams | null>(null);
    if (target) {
        lastTargetRef.current = target;
    }

    return {
        openDrillDown,
        closeDrillDown,
        isOpen: target !== null,
        drawerKey,
        drawerTarget: lastTargetRef.current,
    };
}
